'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _RealtorQuestionsPackages = require('./RealtorQuestionsPackages.scss');var styles = _interopRequireWildcard(_RealtorQuestionsPackages);

var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _packagesData = require('../../packagesData');
var _RealtorQuestionPackage = require('../RealtorQuestionPackage/RealtorQuestionPackage');var _RealtorQuestionPackage2 = _interopRequireDefault(_RealtorQuestionPackage);

var _RealtorQuestionPackageMobile = require('../RealtorQuestionPackage/RealtorQuestionPackageMobile');var _RealtorQuestionPackageMobile2 = _interopRequireDefault(_RealtorQuestionPackageMobile);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var


RealtorQuestionsPackages = function (_Component) {_inherits(RealtorQuestionsPackages, _Component);function RealtorQuestionsPackages() {var _temp, _this, _ret;_classCallCheck(this, RealtorQuestionsPackages);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      selectedPackage: null }, _this.


    changeSelectedPackage = function (id) {return _this.setState({ selectedPackage: id });}, _this.

    renderPackage = function (packageInstance) {return (
        _react2.default.createElement(_RealtorQuestionPackage2.default, {
          handleChoosePackage: _this.props.handleChoosePackage,
          key: packageInstance.id,
          isRtl: _this.props.isRtl,
          packageInstance: packageInstance,
          translate: _this.props.translate,
          locale: _this.props.locale }));}, _this.



    renderPackageMobile = function (packageInstance) {return (
        _react2.default.createElement(_RealtorQuestionPackageMobile2.default, {
          handleChoosePackage: _this.props.handleChoosePackage,
          key: packageInstance.id,
          isRtl: _this.props.isRtl,
          packageInstance: packageInstance,
          translate: _this.props.translate,
          locale: _this.props.locale,
          changeSelectedPackage: _this.changeSelectedPackage,
          selectedPackage: _this.state.selectedPackage }));}, _temp), _possibleConstructorReturn(_this, _ret);}RealtorQuestionsPackages.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.questionPackagesWrapper, { rtl: this.props.isRtl }) },
        _react2.default.createElement('p', { className: styles.title },
          this.props.rootTranslate('buyingLeads')),

        _react2.default.createElement('div', { className: styles.packageWrapper },

          (0, _packagesData.getPackages)(this.props.isAgent, _packagesData.packageTypes.LEADS).
          map(this.props.isMobile ? this.renderPackageMobile : this.renderPackage)),


        _react2.default.createElement('p', { className: styles.excludingVat }, this.props.rootTranslate('excludingVat'))));


  };return RealtorQuestionsPackages;}(_react.Component);


RealtorQuestionsPackages.propTypes = {
  handleChoosePackage: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  packagesTranslate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isAgent: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    translate: (0, _reduxPagan.getLang)(state.lang, 'RealtorPackages'),
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    packagesTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty'),
    isAgent: (0, _get2.default)(state, 'userAuthentication.data.is_agent'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(RealtorQuestionsPackages);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorQuestionsPackages/RealtorQuestionsPackages.js
// module id = 2881
// module chunks = 0